import { render } from "./EditHyperlinksTable.vue?vue&type=template&id=63a572f6&scoped=true"
const script = {}

import "./EditHyperlinksTable.vue?vue&type=style&index=0&id=63a572f6&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a572f6"]])

export default __exports__